module.exports = __webpack_public_path__ + "media/images/banner/japanesecrafts/zh-hans-d2f35a633f77baa91af85b5d045fca1b.png";